/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { getAuthCookies } from 'lorautils/cookies/auth';
import { createAPIAction } from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('auth', [
  'token',
  'revoke',
]);

function token(username, password) {
  return createAPIAction(
    types.token,
    {
      endpoint: '/authentication/token',
      query: {
        username,
        password,
      },
    })();
}

function revoke() {
  const authCookies = getAuthCookies() || {};
  return createAPIAction(
    types.revoke,
    {
      endpoint: '/authentication/revoke',
      query: { token: authCookies.access_token },
    })();
}

export default {
  token,
  revoke,
};




// WEBPACK FOOTER //
// ./src/redux/actions/auth.js